import { render, staticRenderFns } from "./iframenick.vue?vue&type=template&id=374f7d8a&"
import script from "./iframenick.vue?vue&type=script&lang=js&"
export * from "./iframenick.vue?vue&type=script&lang=js&"
import style0 from "./iframenick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports